import { camelize, camelizeKeys } from 'humps';

export const mergeArray = (state, data, ignoreKey) =>
  data.reduce((newState, item) => {
    const override = ignoreKey ? { [camelize(ignoreKey)]: item[ignoreKey] } : {};
    return newState.merge({
      [item.id]: {
        ...camelizeKeys(item),
        ...override,
        _merged: Date.now(),
      },
    });
  }, state);
